import { Injector, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';
import { FormEntityId } from '../kform/kform.component';

/**
 * 提交信息
 */
export interface SubmitInfo {
  action?: string,
  method?: string,
  modelName?: string,
  keyId?: string,
  notShow?: Array<any>,
  injectData?: {};
}
/**
 * 修改模态框基类
 */
export abstract class EditModalBase<T extends FormEntityId<any>> {
  @Input() editData: T;
  @Input() submitInfo: SubmitInfo;
  @Input() onRefresh: Function = null;
  protected modal: NzModalRef;
  loadingSave: boolean = false;
  disabledSave: boolean = false;
  constructor(injector: Injector) {
    this.modal = injector.get(NzModalRef);
  }

  destroyModal(result = null): void {
    this.modal.destroy(result);
  }
}
